import React from 'react';
import styled from 'styled-components';

const breakpoints = {
  mobile: '768px',
  tablet: '1024px',
  desktop: '1440px',
};

const Container = styled.div`
  width: 100%;
  display: flex;
  align-items: flex-start;
  gap: 0.938rem;
  flex-direction: column;
  padding-bottom: 5%;

  @media (max-width: ${breakpoints.mobile}) {
    max-width: 430px;
    gap: 0.5rem;
  }
`;

const ContainerRow = styled.div`
  width: 100%;
  display: flex;
  align-items: flex-start;
  justify-content: flex-end;
  gap: 0.938rem;

  @media (max-width: ${breakpoints.tablet}) {
    max-width: 100%;
    width: 100%;
    gap: 0.5rem;
  }

  &:nth-child(odd) {
    justify-content: flex-start;
  }

  &:last-child {
    justify-content: center;
  }
`;

const GridItem = styled.img`
  max-width: 328px;
  width: 100%;
  height: auto;

  @media (max-width: ${breakpoints.tablet}) {
    max-width: 210px;
  }

  @media (max-width: ${breakpoints.mobile}) {
    max-width: 80px;
  }
`;

const ZigZagGrid = ({ firstRow, secondRow, thirdRow, fourthRow, ...props }) => {
  return (
    <>
      <Container>
        <ContainerRow>
          {firstRow?.map((item, key) => (
            <GridItem {...props} key={key} src={item.src} alt={item.alt} />
          ))}
        </ContainerRow>
        <ContainerRow>
          {secondRow?.map((item, key) => (
            <GridItem {...props} key={key} src={item.src} alt={item.alt} />
          ))}
        </ContainerRow>
        <ContainerRow>
          {thirdRow?.map((item, key) => (
            <GridItem {...props} key={key} src={item.src} alt={item.alt} />
          ))}
        </ContainerRow>
        <ContainerRow>
          {fourthRow?.map((item, key) => (
            <GridItem {...props} key={key} src={item.src} alt={item.alt} />
          ))}
        </ContainerRow>
      </Container>
    </>
  );
};

export default ZigZagGrid;
